import { ReactElement } from "react";
import {
  FreeFormAddressFieldConfig,
  FreeFormAddressElementType,
} from "@evergiving/common/dist/es2015/form";
import { notNil } from "@evergiving/common/dist/es2015/typescriptUtils";

import { FormField } from "@/lib/components/FormField";
import { SingleSelectField } from "./SingleSelectField";
import { CityAutocompleteField } from "./CityAutocompleteField";

export function FreeFormAddressComponent({
  freeFormAddressFieldConfig,
  cityCompletionEndpointUrl,
  currentCountryCode,
}: {
  freeFormAddressFieldConfig: FreeFormAddressFieldConfig;
  cityCompletionEndpointUrl?: string;
  currentCountryCode?: string;
}): ReactElement {
  return (
    <>
      {Object.entries(freeFormAddressFieldConfig)
        .map(([key, value]) => {
          const mayBeElementType:
            | FreeFormAddressElementType
            | undefined = Object.entries(FreeFormAddressElementType).find(
            ([_, v]) => v === key
          )?.[1];

          if (!mayBeElementType || !value) {
            return null;
          }

          if ("options" in value) {
            return <SingleSelectField config={value} name={mayBeElementType} />;
          }

          if (
            key === "element7" &&
            cityCompletionEndpointUrl &&
            currentCountryCode
          ) {
            return (
              <CityAutocompleteField
                fieldName={mayBeElementType}
                key={key}
                config={value}
                cityCompletionEndpointUrl={cityCompletionEndpointUrl}
                currentCountryCode={currentCountryCode}
              />
            );
          }
          return <FormField name={mayBeElementType} key={key} config={value} />;
        })
        .filter(notNil)}
    </>
  );
}
